<div class="container-fluid">
  <div class="row">
    <!-- Sidebar -->
    <div class="col-2 bg-light vh-100 p-3 d-flex flex-column">
      <h5 class="mb-3">Designer</h5>
      <ul class="nav flex-column flex-grow-1">
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/designer/template-list')"
            (click)="navigateTo('/designer/template-list', $event)"
            >Manage Templates</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/designer/layout-list')"
            (click)="navigateTo('/designer/layout-list', $event)"
            >Manage Custom layouts</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/designer/object-group-list')"
            (click)="navigateTo('/designer/object-group-list', $event)"
            >Manage Object Groups</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            [class.active]="isActive('/designer/slide-type-list')"
            (click)="navigateTo('/designer/slide-type-list', $event)"
            >Manage Slide types</a
          >
        </li>
      </ul>
      <div class="border-top pt-3 mt-2 d-grid gap-2">
        <button type="button" class="btn btn-outline-secondary btn-sm text-start" (click)="goBack()">
          ← Back
        </button>
        <button type="button" class="btn btn-outline-danger btn-sm text-start" (click)="requestLogout()">
          Logout
        </button>
      </div>
    </div>

    <!-- Main content -->
    <div class="col-10 p-4">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
